
export const expectedJiraWebhooksToCreateTasks = ({ expectedWebhooks, currentAccountMapping }) => {
  const { id: currentAccountMappingId } = currentAccountMapping;

  const result = {};
  // eslint-disable-next-line no-unused-vars
  for (const { events, jql, used_by_rules, used_by_all_rules } of expectedWebhooks.filter(w => w.type === 'jira_issue_webhook')) {
    const allRules = [
      ...used_by_rules,
      ...used_by_all_rules ? [{ id: 'all_rules' }] : []
    ];

    // eslint-disable-next-line no-unused-vars
    for (const rule of allRules) {
      const key = `jira_${(events || []).sort().join(',')}_${jql}_${currentAccountMappingId}_${rule.id}`;
      result[key] = {
        key,
        createTask: {
          type: 'jira',
          action: 'create',
          events,
          jql,
          queryParams: { rule_id: rule.id, accounts_mapping_id: currentAccountMappingId },
          name: `PagerDuty_managed_${currentAccountMappingId}_${rule.id}`
        }
      };
    }
  }

  return result;
};
